import {PaymentMethod} from "@/lib/types/billing.ts";

import css from "@/pages/billing/payment-method/PaymentMethodDisplay.module.css";

export const PaypalDisplay = ({paymentMethod}: {paymentMethod: PaymentMethod}) => {
  return (
    <>
      <img alt="PayPal Logo" src={paymentMethod.img} className={css.PaymentMethodLogo} />
      {paymentMethod.email}
    </>
  );
};
